import Header from "../../shared/Header";
import Habits from "./Habits";
import Footer from "../../shared/Footer";

export default function HabitsPage (){
    
    return (
        <>
            <Header />
            <Habits />
            <Footer />
        </>
    );
}

